<template>
  <div class="rounded space-y-2">
    <div v-if="deliveryTime" :class="[isFocusedDay ? 'text-yellow-900' : 'text-yellow-500']">
      {{ deliveryTime }}
    </div>
    <div
      :class="[
        'block',
        'text-xs',
        'focus:outline-none',
        'rounded',
        'shadow',
        'border',
        'overflow-hidden',
        isFocused
          ? 'border-yellow-700 bg-yellow-600 text-white'
          : 'bg-yellow-200 border-yellow-500 text-yellow-900',
      ]"
      @click="$emit('edit:production-order', productionOrder)"
    >
      <div v-if="project" class="p-2 font-medium">
        {{ project.name }}
      </div>
      <div class="p-2">
        {{ orderItem.name }}
      </div>
      <div class="px-2 py-1">
        <BaseBadge
          :silver="orderItem.status === 'draft'"
          :custom="orderItem.status === 'pending'"
          :orange="orderItem.status === 'in progress'"
          :red="orderItem.status === 'in review'"
          :green="orderItem.status === 'completed'"
          :class="[orderItem.status === 'pending' ? 'bg-blue-600 text-white' : '']"
        >
          {{ orderItem.status }}
        </BaseBadge>
      </div>
      <div v-if="provider" class="px-2 py-1 flex items-center">
        <svg
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="w-4 h-4 text-yellow-700 mr-2 inline-flex"
        >
          <path
            d="M21 13.255A23.931 23.931 0 0112 15c-3.183
            0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2
            2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2
            2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        {{ provider.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductionOrderCard',

  props: {
    productionOrder: {
      type: Object,
      required: true,
    },
    isFocusedDay: Boolean,
  },

  computed: {
    orderItem() {
      if (!this.productionOrder.orderItems || !this.productionOrder.orderItems.length) {
        return undefined;
      }

      return this.$store.state.entities.orderItems.byId[this.productionOrder.orderItems[0]];
    },
    project() {
      if (!this.productionOrder.projectUuid) {
        return undefined;
      }

      return this.$store.state.entities.projects.byId[this.productionOrder.projectUuid];
    },
    provider() {
      if (!this.productionOrder.providerUuid) {
        return undefined;
      }

      return this.$store.state.entities.accountRelations.byId[this.productionOrder.providerUuid];
    },
    deliveryTime() {
      if (!this.productionOrder.deliveryAt) return '';

      const [, time = ''] = this.productionOrder.deliveryAt.split(' ');

      return time;
    },
    isFocused() {
      if (!this.orderItem) return false;
      if (!this.$route.query.productionOrderItemId) return false;
      return this.$route.query.productionOrderItemId === this.orderItem.uuid;
    },
  },
};
</script>
